
export default {
    mode: process.env.NODE_ENV === 'production' ? 'production' : 'development',
};
